import { Component, AfterViewInit, ViewEncapsulation } from "@angular/core";
import { B2bTransaction, TrackingB2bStatus } from "src/app/models/transaction";
import { TrackingB2bService } from "src/app/services/tracking-b2b.service";
import { DatePipe } from "@angular/common";
import { Alert } from "src/app/models/base-response";
import { LazyLoaderService } from "src/app/services/lazy-loader.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication.service";

import * as $ from "jquery";
import * as firebase from "firebase";

declare var $: any;

@Component({
  selector: "app-tracking-b2b",
  templateUrl: "./tracking-b2b.component.html",
  styleUrls: ["./tracking-b2b.component.css"],
})
export class TrackingB2bComponent implements AfterViewInit {
  statusB2b: string;
  isB2bCustomer = true;

  start: string = "";
  end: string = "";

  transaction: B2bTransaction[] = [];

  isLoading = false;
  isError: boolean = false;
  alert: Alert;

  filterStatus = "";

  canShowMore = false;
  totalRecords: number;
  defaultLimit = 100;
  limit = 10;
  offset = 0;

  get getB2bTrackingStatus() {
    return TrackingB2bStatus;
  }

  constructor(
    private router: Router,
    private lazyLoaderService: LazyLoaderService,
    private datepipe: DatePipe,
    private transService: TrackingB2bService,
    private authService: AuthenticationService
  ) {}

  ngAfterViewInit() {
    this.statusB2b = this.authService.getB2BStatus();

    if (this.statusB2b === "true") {
      firebase.analytics().logEvent("trackingB2b_page");

      setTimeout(() => {
        this.lazyLoaderService.loadScript(
          "https://cdn.jsdelivr.net/npm/gijgo@1.9.6/js/gijgo.min.js"
        );
        this.applyJqueryScript();
        this.resetFilter();
      });
    } else {
      this.router.navigate(["/**"]);
    }
  }

  applyJqueryScript(): void {
    const that = this;
    $(document).ready(function () {
      $(".datepicker").remove();

      $("#startDate").datepicker({
        autoclose: true,
        uiLibrary: "bootstrap4",
        format: "yyyy-mm-dd",
        minDate: new Date(new Date().getTime() - 2592000000),
        maxDate: new Date(),
        change: function (e) {
          that.startDateOnChanged();
        },
      });
      $("#endDate").datepicker({
        autoclose: true,
        uiLibrary: "bootstrap4",
        format: "yyyy-mm-dd",
        minDate: new Date(new Date().getTime() - 2592000000),
        maxDate: new Date(),
        change: function (e) {
          that.endDateOnChanged();
        },
      });

      $("body").click(function (evt) {
        if ($(evt.target).closest(".input-group-append").length) {
          return;
        }

        // if ($(".datepicker").eq(0).css("display") !== "none") {
        //   $(".datepicker").eq(0).css("display", "none");
        // }

        // if ($(".datepicker").eq(1).css("display") !== "none") {
        //   $(".datepicker").eq(1).css("display", "none");
        // }
      });
    });
  }

  loadData() {
    if (this.start !== "" && this.end !== "") {
      this.loadTransaction(
        this.start,
        this.end,
        this.filterStatus,
        this.limit,
        this.offset
      );
    } else if (this.start === "" && this.end === "") {
      const start = this.datepipe.transform(
        new Date().getTime() - 604800000,
        "yyyy-MM-dd"
      );
      const end = this.datepipe.transform(new Date(), "yyyy-MM-dd");
      this.loadTransaction(
        start,
        end,
        this.filterStatus,
        this.limit,
        this.offset
      );
    }
  }

  startDateOnChanged() {
    if (this.start !== $("#startDate").val()) {
      this.transaction = [];
      this.start = $("#startDate").val();
      if (this.end !== "") {
        if (new Date(this.end) < new Date(this.start)) {
          this.end = "";
          $("#endDate").val("");
        }
      }
      this.loadData();
    }
  }

  endDateOnChanged() {
    if (this.end !== $("#endDate").val()) {
      this.transaction = [];
      this.end = $("#endDate").val();
      if (this.start !== "") {
        if (new Date(this.end) < new Date(this.start)) {
          this.start = "";
          $("#startDate").val("");
        }
      }
      this.loadData();
    }
  }

  onChangedStatus(status: string) {
    this.filterStatus = status;
    this.limit = 10;
    this.loadData();
  }

  resetFilter() {
    this.start = "";
    this.end = "";
    $("#startDate").val("");
    $("#endDate").val("");
    this.filterStatus = "";
    this.limit = 10;
    this.loadData();
  }

  loadTransaction(
    start: string,
    end: string,
    filterStatus: string,
    limit: number,
    offset: number
  ) {
    this.isLoading = true;
    this.isError = false;

    this.transService.getB2bTransaction(
      start,
      end,
      filterStatus,
      this.defaultLimit,
      offset,
      (resp) => {
        this.totalRecords = resp.data.length;

        this.transService.getB2bTransaction(
          start,
          end,
          filterStatus,
          limit,
          offset,
          (response) => {
            this.isLoading = false;
            this.alert = response.alert;
            if (response.alert.code === 200) {
              this.transaction = response.data;

              if (this.totalRecords === this.transaction.length) {
                this.canShowMore = false;
              } else {
                this.canShowMore = true;
              }
            } else {
              this.isError = true;
            }
          },
          (err) => {
            this.isLoading = false;
            this.isError = true;
            this.alert.code = 500;
            this.alert.message = err;
          }
        );
      },
      (err) => {
        this.isLoading = false;
        this.isError = true;
        this.alert.code = 500;
        this.alert.message = err;
      }
    );
  }

  showMore() {
    if (this.canShowMore) {
      this.limit = this.limit + 10;
      this.loadData();
    }
  }
}
